import { Component, OnInit, OnDestroy } from '@angular/core';
import { TemplateService } from '../../services/template.service';
import { Chart } from 'chart.js';
import * as _ from 'lodash';
import {SelectItem, TreeNode} from 'primeng/api';
import { ApiService } from '../../services/api.service';
import { SubSink } from 'subsink';
import {HttpParams} from "@angular/common/http";
import {NgbModal, NgbModalRef} from "@ng-bootstrap/ng-bootstrap";
import {LangChangeEvent, TranslateService} from "@ngx-translate/core";
import * as moment from "moment";
import {CALENDAR_LOCALE} from "../../services/constant";
// import {el} from "@angular/platform-browser/checkdateing/src/browser_util";

@Component({
  selector: 'app-email-dashboard',
  templateUrl: './email-dashboard.component.html',
  styleUrls: ['./email-dashboard.component.scss'],
  providers: [TemplateService]
})
export class EmailDashboardComponent implements OnInit, OnDestroy {

  private subs = new SubSink();
  modal: NgbModalRef;
  currentPage = 1;
  itemsPerPage = 40;
  totalItems: number = 0 ;
  transactions_sent:any;
  transactions_failed:any;
  transactions_wait_for_send:any;
  transactions_not_sent:any;
  sentChart: Chart;
  errorChart: Chart;
  notSentChart: Chart;
  clearChart: Chart;
  emailTotal;
  data;
  docType;
  myChart1;
  myChart2;
  myChart3;
  myChart4;
  loading;
  loading_main = false;
  datastatus = [];
  selectedCustomercode =null;
  customercode:any;
  deliverycodeList: any = null;
  selectedDeliverycode = null;
  allDeliverycodeList = [];
  company;
  treeTableValue;
  startDate: Date = null;
  endDate: Date = null;
  minDate: Date;
  maxDate: Date;
  calendarLocale = CALENDAR_LOCALE.TH;
  rdDocumentType: any;
  selectedRdDocumentType: any;
  documentType:any;
  allDocumentType:any;
  email:any;
  sortBy = null;
  checkdate = null;
  sortMode = null;
  defaultLabel = null;

  constructor(private apiService: ApiService,
              private translate: TranslateService,
              private template: TemplateService) {
  }

  ngOnInit() {
    this.loadData();
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      // this.loadTexts();
      this.getEmailReport();
    });
    this.getEmailReport();
    this.rdDocumentType = this.template.getDropdown();
    // this.loadTexts();

  }

  getEmailReport() {
     this.defaultLabel = this.translate.instant('COMMON.ALL');
    this.selectedCustomercode = null;
    this.customercode = null;
    this.selectedRdDocumentType = null;
    this.customercode = [{
      label: this.translate.instant('COMMON.ALL'),
      value: null
    }];
    this.loading_main = true ;
      this.data = this.apiService.getEmailReport().subscribe((res: any) => {
        this.emailTotal = res.transactions_sent+res.transactions_failed;
        this.transactions_sent = res.transactions_sent;
        this.transactions_failed = res.transactions_failed;
        this.transactions_wait_for_send = res.transactions_wait_for_send;
        this.transactions_not_sent = res.transactions_not_sent;
        this.loading_main = false;
         this.generateChart();
        this.getTreeTableValue();
        _.forEach(res.results, (obj) => {
          this.customercode.push({
            label: obj.customer_code,
            value: obj.customer_code
          });
           this.allDeliverycodeList.push({
            label: obj.delivery_code,
            value: obj.customer_code
          })
        });
        this.customercode = _.uniqBy(this.customercode, 'label');
        this.filterDeliverycodeList();
      });
      this.startDate = new Date();
    this.startDate.setFullYear(new Date().getFullYear(), 0, 1);
    this.endDate = new Date();

  }
  getTreeTableValue() {
    this.treeTableValue = {
      'data':
        [
          {
            'data': {
              'name': 'Documents',
              'size': '75kb',
              'type': 'Folder'
            },
            'children': [
              {
                'data': {
                  'name': 'Work',
                  'size': '55kb',
                  'type': 'Folder'
                },
                'children': [
                  {
                    'data': {
                      'name': 'Expenses.doc',
                      'size': '30kb',
                      'type': 'Document'
                    }
                  },
                  {
                    'data': {
                      'name': 'Resume.doc',
                      'size': '25kb',
                      'type': 'Resume'
                    }
                  }
                ]
              },
              {
                'data': {
                  'name': 'Home',
                  'size': '20kb',
                  'type': 'Folder'
                },
                'children': [
                  {
                    'data': {
                      'name': 'Invoices',
                      'size': '20kb',
                      'type': 'Text'
                    }
                  }
                ]
              }
            ]
          },
          {
            'data': {
              'name': 'Pictures',
              'size': '150kb',
              'type': 'Folder'
            },
            'children': [
              {
                'data': {
                  'name': 'barcelona.jpg',
                  'size': '90kb',
                  'type': 'Picture'
                }
              },
              {
                'data': {
                  'name': 'primeui.png',
                  'size': '30kb',
                  'type': 'Picture'
                }
              },
              {
                'data': {
                  'name': 'optimus.jpg',
                  'size': '30kb',
                  'type': 'Picture'
                }
              }
            ]
          }
        ]
    };
  }

  generateChart() {
    const keepchart = this.transactions_sent+this.transactions_failed;
    this.sentChart = new Chart('sentChart', {
      type: 'doughnut',
      data: {
        // labels: ['Red', 'Blue', 'Yellow'],
        datasets: [{
          label: 'Sent Chart',
          data: [this.transactions_sent],
          backgroundColor: [

            '#16c8c8',
            '#5b5a5a',

          ],
          borderColor: [
            '#ededed',
            '#ededed',
          ],
          borderWidth: 1
        }]
      },
      options: {
        responsive: true,
        tooltips: {
          enabled: false,
        },
        cutoutPercentage: 60
      }
    });

    this.errorChart = new Chart('errorChart', {
      type: 'doughnut',
      data: {
        // labels: ['Red', 'Blue', 'Yellow'],
        datasets: [{
          label: '# of Votes',
     data: [this.transactions_failed,keepchart],
          backgroundColor: [
            '#FF6384',
            '#6F6E6E'
          ],
          borderColor: [
            '#ededed',
            '#ededed',
          ],
          borderWidth: 1
        }]
      },
      options: {
        tooltips: {
          enabled: false,
        },
        cutoutPercentage: 60
      }
    });
  }

  pageChanged() {
      this.loadData(this.currentPage);
  }

  setPageSide() {

  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  searchButtonClicked() {
    this.currentPage = 1;
    this.sortBy = null;
    this.sortMode = null;
    this.loadData();
  }
   sentdate(){
    this.checkdate = 1 ;
  }

  loadData(page?,data?){
    this.datastatus = [];
    this.loading_main = true;
    this.customercode;
    let keepstartDate = moment(this.startDate).format('YYYY-MM-DD');
    let keependDate = moment(this.endDate).format('YYYY-MM-DD');
     let params = new HttpParams();

    if (this.selectedCustomercode && this.selectedRdDocumentType ) {
      params = params.append('customer_code', this.selectedCustomercode);
      params = params.append('document_type', this.selectedRdDocumentType);
    }
    if(data) {
        params = params.append('status', data);
    }
    if(this.selectedCustomercode) {
        params = params.append('customer_code', this.selectedCustomercode);
    }
    if(this.selectedRdDocumentType) {
         params = params.append('document_type', this.selectedRdDocumentType);
    }
    if(this.email) {
         params = params.append('email', this.email);
    }
    if(this.selectedDeliverycode) {
         params = params.append('customer_code', this.selectedDeliverycode);
    }
    // else if(keepstartDate)
    if(this.checkdate == 1 ){
    params = params.append('document_date_gte', keepstartDate);
    params = params.append('document_date_lte', keependDate);
    }
    params = params.append('page',this.currentPage.toString());
    params = params.append('page_size', this.itemsPerPage.toString());
    this.apiService.getEmailDashboard(params).subscribe((result) => {
      _.forEach(result.results, (obj) => {
        this.totalItems = result.count;
        this.datastatus.push({
            email_data:obj.email_data.emails,
            cc_email_data:obj.email_data.cc_list,
            document_date:obj.document_date,
            customer_code:obj.customer_code,
            delivery_code:obj.delivery_code,
          document_number:obj.document_number,
          document_type:obj.document_type,
          tax_data:obj.tax_data,
          status:obj.status
        });
      });
      this.loading_main = false ;
    });
  }

   get yearRange() {
    const thisYear = (new Date()).getFullYear();
    return (2020) + ':' + (thisYear);
  }

  get dateRange() {
    if (!this.startDate && !this.endDate) {
      return null;
    }

    const start = this.startDate ? moment(this.startDate).format('DD/MM/YYYY') : '';
    const end = this.endDate ? moment(this.endDate).format('DD/MM/YYYY') : '';
    return start + ' - ' + end;
  }

  setMinDate() {
    this.minDate = this.startDate;
  }

  setMaxDate() {
    this.maxDate = this.endDate;
  }
  clearData(){
    this.transactions_failed = null;
    this.transactions_wait_for_send = null;
    this.transactions_not_sent = null;
    this.transactions_sent = null;
    this.datastatus = null;
    this.startDate = new Date();
    this.startDate.setFullYear(new Date().getFullYear(), 0, 1);
    this.rdDocumentType = null;
    this.deliverycodeList = null;
    this.customercode = null;
    this.email = null;
    this.startDate = null;
    this.endDate = new Date();
    this.startDate = new Date();
    this.sortBy = null;
    this.sortMode = null;
    this.totalItems  =null;
    this.checkdate = null;
    this.currentPage = 1;
    this.selectedDeliverycode=null;
    this.getEmailReport();
    this.loadData();

  }

  filterDeliverycodeList() {
    this.selectedDeliverycode = null;
    this.deliverycodeList = [{
      label: this.translate.instant('COMMON.ALL'),
      value: null
    }];

    _.forEach(this.allDeliverycodeList, (obj) => {
      if(this.selectedCustomercode == null || obj.value == this.selectedCustomercode)
        this.deliverycodeList.push({
          label: obj.label,
          value: obj.value
        })
    });
  }
  stopPropagation(event) {
    event.stopPropagation();
  }

}




// WEBPACK FOOTER //
// /opt/app/src/app/features/email-dashboard/email-dashboard.component.ts